const nlBlogIsdeEindhoven = {
  meta: {
    title: "ISDE-subsidie Eindhoven | Lokale Aanvraag Gids",
    description:
      "ISDE-subsidie aanvragen in Eindhoven ? Plus gemeente Eindhoven energieregelingen. Welke subsidies u kunt combineren voor ramen en glas.",
  },
  hero: {
    h1: "ISDE-subsidie aanvragen in Eindhoven : lokale gids",
    subtitle:
      "Woont u in Eindhoven en wilt u de ISDE-subsidie aanvragen voor energiezuinige ramen ? Hier leest u alles over landelijke en gemeentelijke regelingen specifiek voor Eindhovenaren.",
    image:
      "/img/53-terraced-house-eindhoven-newly.jpg",
    updated: "Laatst bijgewerkt mei 2026",
    readTime: "7 min leestijd",
  },
  sections: {
    isdeEindhoven: {
      h2: "ISDE-subsidie voor inwoners van Eindhoven",
      p1: "De landelijke ISDE-subsidie geldt voor alle Nederlandse woningeigenaren, dus ook voor inwoners van Eindhoven. De regeling dekt de kosten van energiebesparende maatregelen zoals HR++ glas, triple glas, spouwmuurisolatie en vloerisolatie. De subsidiebedragen voor 2026 zijn aantrekkelijk : tussen de € 35 en € 90 per m² voor beglazing, afhankelijk van het type glas.",
      p2: "In Eindhoven en omstreken wonen veel mensen in jaren '60 en '70 rijtjeswoningen met enkel glas of verouderde dubbele beglazing. De energiebesparing die u behaalt door over te stappen op HR++ glas is enorm. Naast lagere stookkosten verbetert ook het wooncomfort aanzienlijk : minder tocht, minder condens en een constantere temperatuur in huis.",
      p3: "Wij adviseren u graag welke maatregelen het meest renderen voor uw specifieke woning in Eindhoven. Elke wijk heeft zijn eigen woningtypes en daarmee specifieke uitdagingen op het gebied van isolatie.",
      linkIsde: {
        text: "Lees onze complete ISDE-subsidie 2026 gids",
        href: "/blog/isde-subsidie-2026/",
      },
    },
    gemeente: {
      h2: "Gemeente Eindhoven : extra energieregelingen",
      p1: "Naast de landelijke ISDE-subsidie biedt de gemeente Eindhoven aanvullende mogelijkheden voor woningeigenaren die willen verduurzamen. Via het energieloket van de gemeente kunt u informatie krijgen over lokale leningen, subsidies en financieringsregelingen voor energiebesparende maatregelen.",
      p2: "De gemeente Eindhoven stimuleert duurzaamheid actief door middel van verschillende programma's. Sommige wijken in Eindhoven maken deel uit van specifieke verduurzamingsprojecten waarbij collectieve inkoop van isolatie en glas mogelijk is. Dit kan de prijs per m² aanzienlijk drukken.",
      p3: "Wij adviseren u om regelmatig de website van de gemeente Eindhoven te raadplegen voor actuele regelingen. Lokale subsidies kunnen per jaar wijzigen en zijn soms tijdelijk beschikbaar. Door landelijke en gemeentelijke subsidies te combineren, maximaliseert u uw voordeel.",
      linkGemeente: {
        text: "Bekijk actuele regelingen op eindhoven.nl",
        href: "https://www.eindhoven.nl",
      },
    },
    combineren: {
      h2: "ISDE en gemeentesubsidie combineren",
      p1: "Een van de grootste voordelen voor Eindhovenaren is de mogelijkheid om landelijke en lokale subsidies te combineren. In de meeste gevallen komt u in aanmerking voor zowel de ISDE-subsidie als een gemeentelijke verduurzamingsregeling, waardoor uw totale subsidiebedrag verder oploopt.",
      p2: "De ISDE-subsidie wordt toegekend op basis van de oppervlakte en het type maatregel. Combineert u glasvervanging met bijvoorbeeld spouwmuurisolatie of dakisolatie, dan stijgt het totaalbedrag. De gemeente Eindhoven biedt soms aanvullende leningen tegen gunstige voorwaarden voor woningeigenaren die meerdere maatregelen tegelijk uitvoeren.",
      p3: "Wij maken graag een totaaladvies voor uw woning. Door te kijken naar het complete isolatiepakket — ramen, kozijnen, spouwmuur, vloer en dak — bepalen wij welke combinatie van maatregelen het meest voordelig is, inclusief alle beschikbare subsidies.",
    },
    energiezuinig: {
      h2: "Energiezuinig wonen in Eindhoven",
      p1: "Eindhoven staat bekend als innovatiestad, maar veel woningen in de regio dateren uit een tijd waarin energiebesparing geen prioriteit was. De typische jaren '60 en '70 rijtjeswoningen in wijken zoals Woensel, Gestel en Tongelre hebben vaak enkel glas of verouderde dubbele beglazing. Deze woningen zijn relatief eenvoudig te verduurzamen met moderne isolatiemaatregelen.",
      p2: "De ASML- en Philips-regio trekt veel technisch onderlegde inwoners die duurzaamheid waarderen. Investeren in HR++ glas past in deze mindset en levert direct resultaat. De gemiddelde besparing op stookkosten na vervanging van enkel glas door HR++ bedraagt € 300 tot € 500 per jaar voor een tussenwoning.",
      p3: "Bovendien verhoogt u met energiezuinige ramen de waarde van uw woning. Kopers in Eindhoven en omstreken letten steeds meer op het energielabel. Een woning met HR++ beglazing scoort hierop significant beter dan een vergelijkbare woning met enkel glas.",
    },
    wijHelpen: {
      h2: "Wij helpen Eindhovenaren met de aanvraag",
      p1: "Als lokale specialist in Eindhoven begrijpen wij de specifieke uitdagingen van woningen in onze regio. Wij kennen de typische kozijnen van jaren '50-, '60- en '70-woningen en weten precies welk type glas het beste past. Onze monteurs zijn dagelijks in Strijp, Woensel, Centrum, Gestel en alle andere wijken van Eindhoven te vinden.",
      p2: "Naast de plaatsing van HR++ glas helpen wij u ook met de subsidieaanvraag. Wij zorgen voor een gedetailleerde factuur met alle specificaties die de RVO vereist : type glas, U-waarde, totale oppervlakte en plaatsingsdatum. Zo start u direct na oplevering met uw aanvraag op mijn.rvo.nl.",
      p3: "Advies over subsidies is altijd gratis. Wij komen vrijblijvend bij u langs voor een inspectie en een offerte op maat. Zo weet u precies welk glas het beste past bij uw woning en hoeveel subsidie u kunt verwachten.",
      linkGlas: {
        text: "Bekijk onze glas vervangen service",
        href: "/glas-vervangen/",
      },
      linkKozijn: {
        text: "Bekijk onze kozijnreparatie service",
        href: "/kozijn-reparatie/",
      },
      linkWijken: {
        text: "Bekijk ons werkgebied",
        href: "/wijken/",
      },
    },
  },
  faq: {
    h2: "Veelgestelde vragen over ISDE in Eindhoven",
    items: [
      {
        q: "Kan ik als inwoner van Eindhoven ISDE-subsidie aanvragen ?",
        a: "Ja, de ISDE-subsidie is een landelijke regeling die geldt voor alle Nederlandse woningeigenaren, inclusief inwoners van Eindhoven. U vraagt de subsidie aan via mijn.rvo.nl na uitvoering van de werkzaamheden door een erkend installateur.",
      },
      {
        q: "Biedt gemeente Eindhoven extra energiesubsidies ?",
        a: "De gemeente Eindhoven biedt soms aanvullende verduurzamingsregelingen via het energieloket. Deze regelingen kunnen per jaar wijzigen. Wij adviseren u om eindhoven.nl te raadplegen voor de meest actuele informatie over lokale subsidies en leningen.",
      },
      {
        q: "Kan ik landelijke en lokale subsidies combineren ?",
        a: "In de meeste gevallen wel. De landelijke ISDE-subsidie kan gecombineerd worden met gemeentelijke regelingen, mits de gemeente dit expliciet toestaat. Door beide subsidies te stacken, maximaliseert u uw totale voordeel. Wij adviseren u graag over de meest voordelige combinatie.",
      },
      {
        q: "Helpen jullie met de subsidieaanvraag in Eindhoven ?",
        a: "Absoluut. Wij leveren na oplevering een complete factuur met alle specificaties die de RVO vereist : type glas, U-waarde, oppervlakte en plaatsingsdatum. Daarnaast adviseren wij u gratis over de aanvraagprocedure op mijn.rvo.nl.",
      },
    ],
  },
  disclaimer:
    "Gemeentelijke regelingen kunnen wijzigen. Raadpleeg altijd eindhoven.nl en rvo.nl voor actuele informatie.",
  cta: {
    text: "ISDE-subsidie in Eindhoven ? Vraag gratis advies aan",
    phone: "040 798 7470",
  },
  schema: {
    headline:
      "ISDE-subsidie aanvragen in Eindhoven : lokale gids",
    description:
      "ISDE-subsidie aanvragen in Eindhoven ? Plus gemeente Eindhoven energieregelingen. Welke subsidies u kunt combineren voor ramen en glas.",
    author: "Ramen Repair Eindhoven",
    datePublished: "2026-05-28",
    dateModified: "2026-05-28",
  },
};

export default nlBlogIsdeEindhoven;